import React from "react";
import s from "./RecordDetailHeader.module.scss";

const RecordDetailHeader = ({ indicatorName, name, indecatorId, id }) => {
  return (
    <div className={s.detailListHeaderContainer}>
      <div className={s.headerTitle}>
        <span>{indicatorName}</span>
        <span>{name}</span>
      </div>
      <div className={s.headerIdContainer}>
        <span>{indecatorId}</span>
        <span>{id}</span>
      </div>
    </div>
  );
};

export default React.memo(RecordDetailHeader);
